module.exports = __webpack_public_path__ + "static/media/loaderDark.fcea0e15.svg";